import React, { useEffect, useRef } from "react";

export interface IMsFileFormRequestProps {
  wopi: IWopiAccess;
}

export const MsRequest = ({ wopi }: IMsFileFormRequestProps) => {
  const formRef: React.MutableRefObject<any> = useRef();

  useEffect(() => {
    formRef?.current?.submit();
  }, [wopi.fileId]);

  return (
    <form
      ref={formRef}
      id="office_form"
      name="office_form"
      target="office_frame"
      action={`${wopi.wopiActionURL}&WOPISrc=${wopi.wopiSrc}/${wopi.fileId}`}
      method="post"
    >
      <input name="access_token" value={wopi.accessToken} type="hidden" />
      <input
        name="access_token_ttl"
        value={wopi.accessTokenTtl}
        type="hidden"
      />
    </form>
  );
};
